import { BannerRequestBody } from 'api/Banner/types'
import { getCerebroHeaders } from 'api/Cerebro/headers'
import {
    CerebroApiOptions,
    CerebroPaginatedResponse,
    CerebroResourceResponse,
} from 'api/Cerebro/types'
import { orgScopedApiClient } from 'api/orgScopedClient'
import { Report } from 'types'

import { AsinSalesEstimateFactRecord } from './types'

export const getSegmentFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<AsinSalesEstimateFactRecord>> =>
    orgScopedApiClient.post(
        '/api/segment_asin_sales_estimate_segmentizer_facts/aggregate/banner/',
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )

export const getSegmentFactsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        `/api/segment_asin_sales_estimate_segmentizer_facts/aggregate/banner/export/`,
        params
    )

export const getSegmentVariantLevelFacts = (
    params: BannerRequestBody,
    options: CerebroApiOptions = {}
): Promise<CerebroPaginatedResponse<AsinSalesEstimateFactRecord>> =>
    orgScopedApiClient.post(
        '/api/segment_variant_level_sales_estimate_facts/aggregate/banner/',
        params,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )

export const getSegmentVariantLevelFactsExport = (
    params: BannerRequestBody
): Promise<CerebroResourceResponse<Report>> =>
    orgScopedApiClient.post(
        `/api/segment_variant_level_sales_estimate_facts/aggregate/banner/export/`,
        params
    )
